import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const Navbar = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const logoutHandler = () => {
    authService.logout();
    navigate('/login');
    window.location.reload();
  };

  return (
    <nav className="bg-brand-green dark:bg-gray-800 text-white shadow-md transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo / Brand Name */}
          <div className="flex items-center">
            <Link 
              to="/" 
              className="text-2xl font-bold tracking-wide text-brand-gold-light hover:text-white transition-colors duration-200"
            >
              CarbonSasa
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="block">
            <div className="flex items-baseline space-x-2">
              
              {/* GLOBAL HOME BUTTON (Visible to Everyone) */}
              <Link
                to="/"
                className="hover:bg-brand-green-dark dark:hover:bg-gray-700 px-2 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200"
              >
                Home
              </Link>

              {user ? (
                <>
                  <Link
                    to="/dashboard"
                    className="hidden sm:block hover:bg-brand-green-dark dark:hover:bg-gray-700 px-2 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200"
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/stats"
                    className="hidden sm:block hover:bg-brand-green-dark dark:hover:bg-gray-700 px-2 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200"
                  >
                    Impact Report
                  </Link>
                  
                  <button
                    onClick={logoutHandler}
                    className="bg-brand-gold dark:bg-brand-gold-light dark:text-gray-900 hover:bg-brand-gold-light text-brand-green-dark font-bold px-2 py-1 rounded-md text-xs sm:text-sm transition-colors duration-200"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="hover:bg-brand-green-dark dark:hover:bg-gray-700 px-2 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200"
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="bg-white text-brand-green dark:bg-gray-700 dark:text-brand-gold-light font-bold hover:bg-brand-gold-light px-2 py-1 rounded-md text-xs sm:text-sm transition-colors duration-200"
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;